// src/helpers/useWebSocket.js

import { ref, onUnmounted } from "vue"

const isAudioComplete = ref(false)
const isPlaying = ref(false)
const audioEnded = ref(false) // <--- değişiklik

const isLoading = ref(true)

const socket = ref(null)
const isConnected = ref(false)

const connectionError = ref(false)

const analyser = ref(null) // <--- değişiklik

const isMuted = ref(false)
let gainNode = null

export function useWebSocket() {
  let audioContext = null
  let nextPlayTime = 0
  const audioQueue = []

  // 🔥 YENİ: Minimum buffer ayarı
  const MIN_BUFFER_CHUNKS = 1

  const connect = async (url) => {
    try {
      socket.value = new WebSocket(url)
      socket.value.binaryType = "arraybuffer"
      initAudioContext()
      socket.value.onopen = () => {
        isConnected.value = true
        socket.value.send(JSON.stringify({ OK: "OK" }))
      }
      socket.value.onmessage = (event) => {
        if (typeof event.data === "string") {
          const response = JSON.parse(event.data)
          if (response.error) {
            console.log("Hata:", response.error)
            return
          }
        } else {
          audioQueue.push(event.data)

          // 🔥 YENİ: Buffer dolduysa oynatmaya başla
          if (!isPlaying.value && audioQueue.length >= MIN_BUFFER_CHUNKS) {
            playNextChunk()
          }
        }
      }
      socket.value.onerror = (error) => {
        console.log("WebSocket hatası:", error)
        isLoading.value = false
        isConnected.value = false
        connectionError.value = true
      }
      socket.value.onclose = () => {
        isConnected.value = false
      }
    } catch (err) {
      alert(err)
      console.error("WebSocket bağlantısı kurulamadı:", err)
    }
  }

  const send = (msg) => {
    if (socket.value && socket.value.readyState === WebSocket.OPEN) {
      socket.value.send(msg)
    }
  }

  function initAudioContext() {
    try {
      audioContext = new (window.AudioContext || window.webkitAudioContext)()
      gainNode = audioContext.createGain()
      gainNode.gain.value = isMuted.value ? 0 : 1
      analyser.value = audioContext.createAnalyser() // <--- değişiklik
      analyser.value.fftSize = 256
      analyser.value.connect(gainNode)
      gainNode.connect(audioContext.destination)

      nextPlayTime = audioContext.currentTime
    } catch (e) {
      alert("AudioContext başlatılamadı")
      console.error("AudioContext hatası:", e)
    }
  }

  function setMute(val) {
    isMuted.value = val
    if (gainNode) gainNode.gain.value = val ? 0 : 1
  }

  async function playNextChunk() {
    if (!audioContext || audioQueue.length === 0) {
      isPlaying.value = false
      return
    }
    isPlaying.value = true
    const chunk = audioQueue.shift()

    try {
      let arrayBuffer
      if (chunk instanceof Blob) {
        arrayBuffer = await chunk.arrayBuffer()
      } else if (chunk instanceof ArrayBuffer) {
        arrayBuffer = chunk
      } else {
        console.error("Bilinmeyen veri tipi:", chunk)
        return
      }
      let audioBuffer
      try {
        audioBuffer = await audioContext.decodeAudioData(arrayBuffer)
      } catch (e) {
        console.error("error:", e)
      }
      const source = audioContext.createBufferSource()
      source.buffer = audioBuffer
      // --------- DEĞİŞİKLİK: Sesi analyser'a bağla DESTINATION yerine!
      source.connect(analyser.value)
      // analyser zaten destination'a bağlı
      const currentTime = audioContext.currentTime
      const scheduledTime = Math.max(nextPlayTime, currentTime + 0.05)
      source.start(scheduledTime)
      isLoading.value = false

      nextPlayTime = scheduledTime + audioBuffer.duration
      source.onended = () => {
        if (audioQueue.length > 0) {
          playNextChunk()
        } else {
          isPlaying.value = false
          // opsiyonel, tamam işaretlendiyse
          audioEnded.value = true
          socket.value.close()
        }
      }
    } catch (e) {
      alert("Chunk oynatılırken hata oluştu")
      console.error("Chunk oynatma hatası:", e)
    }
  }

  onUnmounted(() => {
    if (socket.value) {
      // socket.value.close()
    }
    if (audioContext) {
      audioContext.close()
    }
  })

  return {
    connect,
    send,
    audioQueue,
    isConnected,
    isAudioComplete,
    analyser, // <--- dışarı çıkarıldı
    audioEnded,
    initAudioContext,
    isLoading,
    setMute,
    isMuted,
    connectionError,
  }
}
